<template>
  <div class="space-y-6 sm:px-6 lg:px-2 lg:max-w-5xl lg:mx-auto" data-test="invited-users">
    <div class="shadow sm:rounded-md sm:overflow-hidden">
      <div class="bg-white py-6 px-4 sm:p-6">
        <div class="border-b border-gray-200 pb-1">
          <h2 id="payment_details_heading" class="text-lg leading-6 font-medium text-gray-900">
            Pending invitations
          </h2>
          <p class="mt-1 text-sm text-gray-700">Users invited to your Heffron IQ account</p>
        </div>
        <div class="mt-2 max-h-56 overflow-y-auto">
          <ul
            v-if="!loading && invites.length > 0"
            class="divide-y divide-gray-200"
          >
            <account-user-invite-item
              v-for="invite in invites"
              :key="invite.uuid"
              :invite="invite"
              @invite-revoked="$emit('invite-revoked')"
            />
          </ul>
          <div
            v-else-if="!loading && invites.length === 0"
            class="text-sm text-gray-700"
          >
            No Invited Users
          </div>
          <m-content-loader v-else class="mt-2 w-1/2"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountUserInviteItem from './account-user-invite-item/account-user-invite-item.vue';

export default {
  name: 'account-invite-user-list',
  components: {
    AccountUserInviteItem,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    invites: {
      type: Array,
    },
  },
};
</script>
